<!-- <h2 mat-dialog-title class="dialog_title">
    <span>
        {{ "Move chat(s) to other job" | translate }}:
    </span>
    <button class="ml-1" mat-icon-button (click)="close()">
        <mat-icon>close</mat-icon>
    </button>
</h2> -->
<mat-dialog-content class="mat-typography">
    <div class="container form_wrapper">
        <mat-tab-group [selectedIndex]="activeIndex" (selectedIndexChange)="changeTab($event)">
            <mat-tab *ngIf="cardJobs && cardJobs.length > 1">
                <ng-template mat-tab-label>
                    <mat-icon class="example-tab-icon mr-1">badge</mat-icon>
                    {{ "Card jobs" | translate }}
                </ng-template>
                <form [formGroup]="form" class="form_with_pads form_with_valids">
                    <mat-form-field appearance="standard" class="full_width_form">
                        <mat-label>{{ "Select job" | translate }}</mat-label>
                        <!-- (selectionChange)="selectValue($event)" -->
                        <mat-select [disableOptionCentering]="true" selectDir #consistContainer formControlName="task_operation_id">
                            <mat-select-trigger>
                                <div class="job_item" *ngIf="form.get('task_operation_id').value && getCardJobById(form.get('task_operation_id').value)">
                                    <div class="item_header">
                                        <div class="primary_tag">
                                            <div class="text_one_line">{{ getCardJobById(form.get('task_operation_id').value)?.operation?.name }}</div>
                                            <span *ngIf="getPrimaryTag(getCardJobById(form.get('task_operation_id').value))" class="text_one_line val">{{getPrimaryTag(getCardJobById(form.get('task_operation_id').value))?.parameterValue?.value}}</span>
                                        </div>
                                        <div class="id">{{ getCardJobById(form.get('task_operation_id').value)?.id }}</div>
                                    </div>
                                    <div class="name text_one_line">{{ getCardJobById(form.get('task_operation_id').value)?.name }}</div>
                                </div>
                            </mat-select-trigger>

                            <mat-option>
                                <ngx-mat-select-search 
                                placeholderLabel="{{ 'Search' | translate }}" 
                                noEntriesFoundLabel="{{ 'no matching card jobs found' | translate }}"
                                [formControl]="cardJobControl"></ngx-mat-select-search>
                            </mat-option>
            
                            <mat-option *ngFor="let job of cardJobs$ | async" class="job_option" [value]="job.id">
                                <div class="job_item">
                                    <div class="item_header">
                                        <div class="primary_tag">
                                            <div class="text_one_line">{{ job?.operation?.name }}</div>
                                            <span *ngIf="getPrimaryTag(job)" class="text_one_line val">{{getPrimaryTag(job)?.parameterValue?.value}}</span>
                                        </div>
                                        <div class="id">{{ job?.id }}</div>
                                    </div>
                                    <div class="name text_one_line">{{ job?.name }}</div>
                                </div>
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </form>
            </mat-tab>
            <mat-tab>
                <ng-template mat-tab-label>
                    <mat-icon class="example-tab-icon mr-1">badge</mat-icon>
                    {{ "All jobs" | translate }}
                </ng-template>
                <form [formGroup]="form" class="form_with_pads form_with_valids">
                    <!-- <mat-form-field appearance="standard" class="full_width_form">
                        <mat-label>{{ "Select job" | translate }}</mat-label>
                        <mat-select [disableOptionCentering]="true" selectDir #consistContainer formControlName="task_operation_id">
                            <mat-select-trigger>
                                <div class="job_item" *ngIf="form.get('task_operation_id').value && getJobById(form.get('task_operation_id').value)">
                                    <div class="item_header">
                                        <div class="primary_tag">
                                            <div class="text_one_line">{{ getJobById(form.get('task_operation_id').value)?.operation?.name }}</div>
                                            <span *ngIf="getPrimaryTag(getJobById(form.get('task_operation_id').value))" class="text_one_line val">{{getPrimaryTag(getJobById(form.get('task_operation_id').value))?.parameterValue?.value}}</span>
                                        </div>
                                        <div class="id">{{ getJobById(form.get('task_operation_id').value)?.id }}</div>
                                    </div>
                                    <div class="name text_one_line">{{ getJobById(form.get('task_operation_id').value)?.name }}</div>
                                    <div class="name text_one_line" style="color: #686868; font-size: 10px;">{{ getJobById(form.get('task_operation_id').value)?.task?.name }}</div>
                                </div>
                            </mat-select-trigger>
                            <mat-option>
                                <ngx-mat-select-search 
                                placeholderLabel="{{ 'Search' | translate }}" 
                                noEntriesFoundLabel="{{ 'no matching jobs found' | translate }}"
                                [formControl]="jobControl"></ngx-mat-select-search>
                            </mat-option>
            
                            <mat-option *ngFor="let job of jobs$ | async" class="job_option" [value]="job.id">
                                <div class="job_item">
                                    <div class="item_header">
                                        <div class="primary_tag">
                                            <div class="text_one_line">{{ job?.operation?.name }}</div>
                                            <span *ngIf="getPrimaryTag(job)" class="text_one_line val">{{getPrimaryTag(job)?.parameterValue?.value}}</span>
                                        </div>
                                        <div class="id">{{ job?.id }}</div>
                                    </div>
                                    <div class="name text_one_line">{{ job?.name }}</div>
                                    <div class="name text_one_line" style="color: #686868; font-size: 10px;">{{ job?.task?.name }}</div>
                                </div>
                            </mat-option>
                        </mat-select>
                    </mat-form-field> -->


                    <mat-form-field appearance="standard" class="full_width_form">
                        <mat-label>{{ "Select job" | translate }}</mat-label>
                        <!-- (selectionChange)="selectValue($event)" -->
                        <mat-select [disableOptionCentering]="true" selectDir formControlName="task_operation_id" msInfiniteScroll (infiniteScroll)="onScroll($event, 'newJobControl')">
                            <mat-select-trigger>
                                <ng-container *ngIf="selectedJob">
                                    <div class="job_item">
                                        <div class="item_header">
                                            <div class="primary_tag">
                                                <div class="text_one_line">{{ selectedJob?.operation?.name }}</div>
                                                <span *ngIf="getPrimaryTag(selectedJob)" class="text_one_line val">{{getPrimaryTag(selectedJob)?.parameterValue?.value}}</span>
                                            </div>
                                            <div class="id">{{ selectedJob?.id }}</div>
                                        </div>
                                        <div class="name text_one_line">{{ selectedJob?.name }}</div>
                                        <div class="name text_one_line" style="color: #686868; font-size: 10px;">{{ selectedJob?.task?.name }}</div>
                                    </div>
                                </ng-container>
                            </mat-select-trigger>
                            <mat-option>
                                <ngx-mat-select-search 
                                placeholderLabel="{{ 'Search' | translate }}" 
                                noEntriesFoundLabel="{{ 'no matching jobs found' | translate }}"
                                [formControl]="newJobControl"></ngx-mat-select-search>
                            </mat-option>
            
                            <mat-option *ngFor="let job of newJobs" [value]="job.id" (click)="selectJob(job)">
                                <div class="job_item">
                                    <div class="item_header">
                                        <div class="primary_tag">
                                            <div class="text_one_line">{{ job?.operation?.name }}</div>
                                            <span *ngIf="getPrimaryTag(job)" class="text_one_line val">{{getPrimaryTag(job)?.parameterValue?.value}}</span>
                                        </div>
                                        <div class="id">{{ job?.id }}</div>
                                    </div>
                                    <div class="name text_one_line">{{ job?.name }}</div>
                                    <div class="name text_one_line" style="color: #686868; font-size: 10px;">{{ job?.task?.name }}</div>
                                </div>
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </form>
            </mat-tab>
        </mat-tab-group>
    </div>
</mat-dialog-content>
<mat-dialog-actions align="end" style="margin-top: 5px;">
    <div class="f_w_p_btns">
        <button mat-raised-button (click)="close()">
            {{ "Close" | translate }}
        </button>
        <button class="ml-1 d-f-btn" (click)="onSubmit()" mat-raised-button cdkFocusInitial color="primary" [disabled]="!form.valid || isSubmit">
            <mat-spinner class="spin_16 mr-1" *ngIf="isSubmit"></mat-spinner>  
            <ng-container *ngIf="isSubmit">
                <div>
                    <div style="line-height: 20px;">{{ "Chats are being moved" | translate }}</div>
                    <div style="font-size: 8px; text-align: left; line-height: 16px;">{{ "Please wait" | translate }}</div>
                </div>
            </ng-container>
            <ng-container *ngIf="!isSubmit">{{"Move" | translate}}</ng-container>
        </button>
    </div>
</mat-dialog-actions>
